import React, { Component } from 'react';

import Modal from '../../components/UI/Modal/Modal';
import { Logout } from 'react-cognito';
import Button from '../../components/UI/Button/Button';
import './withErrorHandler.css'; 
import Icon from '../../components/UI/Icon/Icon';
import ConsoleLog from '../ConsoleLog/ConsoleLog';

/**
* @desc component for displaying the error in api calls.
* @version 
* @author Jamshith P 
*/
const withErrorHandler = ( WrappedComponent, axios ) => {
  ConsoleLog("WrappedComponent",WrappedComponent)
  return class extends Component {
    state = {
      error: null
    }

    /**
    * @desc initializing the error component
    * @param null
    * @return null
    */
    componentWillMount () {
      this.reqInterceptor = axios.interceptors.request.use( req => {
        this.setState( { error: null } );
        return req;
      });
      this.resInterceptor = axios.interceptors.response.use( res => res, error => {
        this.setState( { error: error } );
        //this.logoutClickHandler();
      });

    }

    /**
    * @desc clearing the reqInterceptor in component unmount
    * @param null
    * @return null
    */
    componentWillUnmount () {
      axios.interceptors.request.eject( this.reqInterceptor );
      axios.interceptors.response.eject( this.resInterceptor );
    }

    // componentDidMount(){
    //   window.scrollTo(0,0);
    // }

    componentDidUpdate(){
      if(this.state.error){
        window.scrollTo(0,0);
      } 
    }

    /**
    * @desc closing the modal pop-up
    * @param null
    * @return null
    */
    errorConfirmedHandler = () => {
      this.setState( { error: null } );
    }

    logoutClickHandler = () => {
      this.refs.logoutDivRef.click();
    }
    handleClick = (e) => {
      e.preventDefault();
      window.location.reload();
    }

    /**
    * @desc render the error modal
    * @param null
    * @return DOM  element
    */
    render () {
      return (
        <div className={this.state.error? "network-error error-modal": "network-error"} >

          {/* <Logout><div ref="logoutDivRef"></div></Logout> */}
          <Modal
            show={this.state.error}
            modalClosed={this.errorConfirmedHandler}
            className="network-error-modal">
            {this.state.error ? 
              <div className="network-error-msg">
                <Icon icon="network-error-msg" className ="network-error-msg-icon"/>
                <span className="error-msg-content">Something went wrong!</span>
                <p>{"We're having trouble connecting to the network.\nYour recent changes may not be saved."}</p>
                <Button className="error-msg-ok" onClick={(event)=>this.handleClick(event)}>OK</Button>
              </div>
            : null}
          </Modal>
          <WrappedComponent {...this.props} />
        </div>
      );
    }
  }
}

export default withErrorHandler;


// WEBPACK FOOTER //
// ./src/hoc/withErrorHandler/withErrorHandler.js